import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { delByPathId, postDevices } from 'services/api';
import { normalizeDataTableDevices } from './operators';

export interface DevicesState {
  deviceList: {
    data: any;
    dataTableList: any;
    filterableValues: any;
    pagination: {
      total: number;
      page: number;
    };
    status: null | 'idle' | 'loading' | 'failed';
  };
  openChangeDeviceUser: {
    open: boolean;
    tab: string | null | undefined;
  };
  changeDeviceUserSelected: null | any;
}

const initialState: DevicesState = {
  deviceList: {
    data: [],
    dataTableList: [],
    filterableValues: {},
    pagination: {
      total: 0,
      page: 1,
    },
    status: null,
  },
  openChangeDeviceUser: {
    open: false,
    tab: null,
  },
  changeDeviceUserSelected: null,
};

export const postDevicesAsync: any | null = createAsyncThunk('devices/postDevices', async (data) => {
  const response = await postDevices(data);
  return response?.data;
});

export const delByPathIdDevicesAsync: any | null = createAsyncThunk(
  'devices/delByPathId',
  async (data: any) => {
    const response = await delByPathId(data.path, data.id);
    return response;
  },
);

export const devicesSlice = createSlice({
  name: 'devices',
  initialState,
  reducers: {
    setOpenChangeDeviceUser: (state, action: PayloadAction<any>) => {
      state.openChangeDeviceUser.open = action.payload.open;
      state.openChangeDeviceUser.tab = action.payload.tab;
    },
    setChangeDeviceUserSelected: (state, action: PayloadAction<any>) => {
      state.changeDeviceUserSelected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postDevicesAsync.pending, (state) => {
        state.deviceList.status = 'loading';
      })
      .addCase(postDevicesAsync.fulfilled, (state, action) => {
        state.deviceList.status = 'idle';
        state.deviceList.data = action.payload;
        state.deviceList.dataTableList = normalizeDataTableDevices(action.payload);
        state.deviceList.filterableValues = action.payload?.item?.filterableValues;
        state.deviceList.pagination.total = action.payload?.item?.total;
      })
      .addCase(postDevicesAsync.rejected, (state) => {
        state.deviceList.status = 'failed';
      })
      .addCase(delByPathIdDevicesAsync.fulfilled, (state, action) => {
        state.deviceList.dataTableList = state.deviceList.dataTableList.filter(
          (item: any) => item.id !== action.meta.arg.id,
        );
      });
  },
});

export const { setOpenChangeDeviceUser, setChangeDeviceUserSelected } = devicesSlice.actions;

export default devicesSlice.reducer;
